import { ErrorPage } from "@/components/error-page/error-page";

export function NotFoundView() {
  return <ErrorPage />;
}
